<template>
  <div>
    <input class="form-control" type="text" plcaholder="test">
  </div>
  <!--  Usage Example
<Datepicker
    v-model="selecteDate"
    :options="{
          viewMode: 'day'
  }" />-->
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Datepicker',
  props: ['options', 'value'],
  data () {
    let self = this
    let currentCalendarType = 'gregorian'
    if (this.$store.getters['tenantConfig/tenantInfo']) {
      let normalizedLocal = this.$store.getters[
        'tenantConfig/tenantInfo'
      ].defaultLanguage.toLowerCase()
      if (normalizedLocal == 'en') {
        currentCalendarType = 'gregorian'
      } else if (normalizedLocal == 'fa') {
        currentCalendarType = 'persian'
      }
    }
    return {
      datepickerDefaultOptions: {
        calendarType: currentCalendarType,
        inline: false,
        format: 'L',
        viewMode: 'day',
        persianDigit: true,
        initialValue: true,
        initialValueType: 'persian',
        autoClose: true,
        position: 'auto',
        onlyTimePicker: false,
        onlySelectOnDate: false,
        inputDelay: 800,
        observer: true,
        onSelect: function (unix) {
          self.$emit(
            'input',
            new persianDate(unix)
              .toCalendar('gregorian')
              .toLocale('en')
              .format('YYYY/MM/DD')
          )
        },
        calendar: {
          persian: {
            locale: 'fa',
            showHint: false,
            leapYearMode: 'algorithmic'
          },
          gregorian: {
            locale: 'en',
            showHint: false
          }
        },
        navigator: {
          enabled: true,
          scroll: {
            enabled: true
          },
          text: {
            btnNextText: '<',
            btnPrevText: '>'
          }
        },
        toolbox: {
          enabled: true,
          calendarSwitch: {
            enabled: false,
            format: 'MMMM'
          },
          todayButton: {
            enabled: true,
            text: {
              fa: 'امروز',
              en: 'Today'
            }
          },
          submitButton: {
            enabled: false,
            text: {
              fa: 'تایید',
              en: 'Submit'
            }
          },
          text: {
            btnToday: 'امروز'
          }
        },
        timePicker: {
          enabled: false
        },
        dayPicker: {
          enabled: true,
          titleFormat: 'YYYY MMMM'
        },
        monthPicker: {
          enabled: true,
          titleFormat: 'YYYY'
        },
        yearPicker: {
          enabled: true,
          titleFormat: 'YYYY'
        }
      }
    }
  },
  mounted () {
    this.pdatepicker = $(this.$el)
      .children('input')
      .persianDatepicker(
        Object.assign(this.datepickerDefaultOptions, this.options)
      )
    let defaultValue = new Date(this.value).valueOf()
    this.pdatepicker.setDate(defaultValue)
  }
}
</script>
